import { getQueryParam } from '@mi-front/core';

export const THUMBNAIL_BORDER_SIZE = 2;

export const THUMBNAIL_HEIGHT = getQueryParam('thumbnail_height')
  ? Number(getQueryParam('thumbnail_height'))
  : 115;
